import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
const apiUrl = import.meta.env.VITE_API_URL;

const GenderSelectFilter2 = ({ categorySlug, subcategorySlug }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [genders, setGenders] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState({});

  useEffect(() => {
    axios.get(`${apiUrl}/api/genders`).then(response => {
      const genders = response.data.map(gender => ({
        id: gender.id,
        title: i18n.language === 'ar' ? gender.title_ar : gender.title_en,
      }));
      setGenders(genders);

      const genderIds = searchParams.get('gender_id')?.split(',').map(Number) || [];
      const initialSelected = genders.reduce((acc, gender) => {
        acc[gender.id] = genderIds.includes(gender.id);
        return acc;
      }, {});
      setSelectedGenders(initialSelected);
    }).catch(error => console.error('Error fetching genders:', error));
  }, [i18n.language, searchParams]);

  const handleGenderClick = (genderId) => {
    const updatedSelectedGenders = {
      ...selectedGenders,
      [genderId]: !selectedGenders[genderId],
    };
    setSelectedGenders(updatedSelectedGenders);

    const selectedGenderIds = Object.keys(updatedSelectedGenders)
      .filter(id => updatedSelectedGenders[id])
      .map(Number);

    const currentParams = new URLSearchParams(searchParams);
    if (selectedGenderIds.length > 0) {
      currentParams.set('gender_id', selectedGenderIds.join(','));
    } else {
      currentParams.delete('gender_id');
    }

    const slug = subcategorySlug || categorySlug;
    if (!slug) {
      return;
    }
    const type = subcategorySlug ? 'subcategory' : 'category';
    navigate(`/products/${type}/${slug}?${currentParams.toString()}`);
  };

  return (
    <div className="sidebar-single-area">
      <h3 className="sidebar-single-area__title">{t('Gender')}</h3>
      <ul className="product-categories gender-search">
        {genders.map((gender) => (
          <li className="cat-item" key={gender.id}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id={gender.id}
                checked={selectedGenders[gender.id] || false}
                onChange={() => handleGenderClick(gender.id)}
              />
              <label className="form-check-label" htmlFor={gender.id}>
                {gender.title}
              </label>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GenderSelectFilter2;